// smooth scroll
var scroll = new SmoothScroll('a[href*="#"]', {
speedAsDuration:true,
speed:1000,
easing:'easeInOutQuint'
});





jQuery(document).ready(function(){

	//slick
	jQuery('#anywhere_slide').slick({
		slidesToShow: 3,
		autoplay: true,
		autoplaySpeed: 1800,
		arrows: false,
		centerMode: true,
		centerPadding: "10%",
		speed: 300,
		rtl: true,
		pauseOnHover: true,
		responsive: [{
			breakpoint: 1300,
			settings: {
				centerPadding: "20%",
				slidesToShow: 2
			}
		}, {
			breakpoint: 768,
			settings: {
				centerPadding: "30%",
				slidesToShow: 1
			}
		}]
	});

	jQuery('#gift_slide').slick({
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		speed: 300, 
		dots: true
	});

	
	//tree
	jQuery('#tree li').click(function(){
		jQuery(this).toggleClass('tree_tap');
	});
	
	//rotate
	jQuery('#rotate_btn').click(function(){
		jQuery('#rotate').fadeIn();
	});
	jQuery('#rotate_close').click(function(){
		jQuery('#rotate').fadeOut();
	});
	
	
	
	//interview
	jQuery('#interview_youtube').click(function(){
		jQuery('#youtube').fadeIn();
	});	
	jQuery('#youtube_btn').click(function(){
		jQuery('#youtube').fadeOut();
	});	
	
});

//rotate
jQuery(window).on('load', function($){
	jQuery('#rotate').addClass('rotate_on');
});














/*		トップページFV
=============================== */

jQuery(document).ready(function($) {
	
	setTimeout(function(){
		jQuery('.fv_one').addClass('action');
	},200);
	setTimeout(function(){
		jQuery('.fv_two').addClass('action');
	},1500);
	setTimeout(function(){
		jQuery('.fv_three').addClass('action');
	},2000);

});



/*		scroll and show
=============================== */
jQuery(window).on('scroll',function ($){
   let triggerClass = jQuery('.ss');
	 	animateClass = ('ss_on');
	 	triggerClass2 = jQuery('.ss2');
	 	animateClass2 = ('ss2_on');
	 	triggerClass3 = jQuery('.ss3');
	 	animateClass3 = ('ss3_on');

   jQuery(triggerClass).each(function($){ //即時発火
     let scroll       = jQuery(window).scrollTop(), //スクロール位置を取得
         triggerTop   = jQuery(this).offset().top,  //指定要素のY座標
         windowHeight = jQuery(window).height();    //ウィンドウの高さ
     // 要素が画面中央に来た時に発火
     if (scroll > triggerTop - windowHeight / 1.4){
       jQuery(this).addClass(animateClass);
     }		 
	 });
	 
   jQuery(triggerClass2).each(function($){ //0.5秒後発火
     let scroll       = jQuery(window).scrollTop(), //スクロール位置を取得
         triggerTop   = jQuery(this).offset().top,  //指定要素のY座標
         windowHeight = jQuery(window).height();    //ウィンドウの高さ
		 let myself = this;
     // 要素が画面中央に来た時に発火
     if (scroll > triggerTop - windowHeight / 1.4){
				setTimeout(function(){
						 jQuery(myself).addClass(animateClass2);
				},1000);
     }		 
	 });

	jQuery(triggerClass3).each(function($){ //1.0秒後発火
     let scroll       = jQuery(window).scrollTop(), //スクロール位置を取得
         triggerTop   = jQuery(this).offset().top,  //指定要素のY座標
         windowHeight = jQuery(window).height();    //ウィンドウの高さ
		 let myself = this;
     // 要素が画面中央に来た時に発火
     if (scroll > triggerTop - windowHeight / 1.4){
				setTimeout(function(){
						 jQuery(myself).addClass(animateClass3);
				},2000);
     }		 
	 });
	 
 });
	


